module.exports = __webpack_public_path__ + "static/media/card-mastercard-logo.90ffa928.svg";